import { RefundStatus, RefundStatusTitle } from 'types';

import { FilterValues } from '../types';

export const initialValues: FilterValues = {
  status: '',
  userIds: [],
};

export const statusOptions = Object.values(RefundStatus).map((value) => ({
  value,
  label: RefundStatusTitle[value],
}));
